'use strict';

import { view } from '@/functions';
import { SALES_TEAM_POSITIONS } from '@/data/sales-team-positions';
import { ENGINEERING_READ_SCOPES } from '@/utils/charts/engineering';

const chartsChild = (path, title, scope, viewPath = null, name = null, bypassPositions = undefined) => ({
    path,
    name: name || (path ? `charts-${path}` : 'charts'),
    meta: {
        title,
        scopes: [scope].flat(),
        bypassPositions,
    },
    component: () => view(viewPath || (path ? `charts/${path}` : 'charts/index')),
});

const portfolioChild = (path, title, scope, viewPath = null, name = null) =>
    chartsChild(path, title, scope, viewPath, name, SALES_TEAM_POSITIONS);

export default [
    {
        path: '/charts',
        component: () => view('charts/layout'),
        children: [
            portfolioChild('', 'Charts', 'read_charts'),
            portfolioChild('total-sales', 'Total sales', 'read_charts_total_sales'),
            portfolioChild('salespeople/:adminId', 'Salesperson', 'read_charts_salespeople', 'charts/salesperson', 'charts-salesperson'),
            portfolioChild('salespeople', 'Salespeople', 'read_charts_salespeople'),
            chartsChild('partners/:partnerId', 'Partner', 'read_charts_partners', 'charts/partner', 'charts-partner'),
            chartsChild('partners', 'Partners', 'read_charts_partners'),
            portfolioChild('accounts', 'Accounts', 'read_charts_accounts'),
            chartsChild('product-usage', 'Product usage', 'read_charts_product_usage'),
            portfolioChild('customers', 'Customers', 'read_charts_customers'),
            portfolioChild('customers-churning', 'Churning', 'read_charts_customers'),
            portfolioChild('customers-acquisition', 'Acquisition', 'read_charts_customers'),
            portfolioChild('customers-activation', 'Activation', 'read_charts_customers'),
            chartsChild('customer-liability/:currency', 'Owed to customers', 'read_charts_customer_liability', 'charts/customer-liability-detail', 'charts-customer-liability-detail'),
            chartsChild('customer-liability', 'Owed to customers', 'read_charts_customer_liability'),
            chartsChild('chargebacks', 'Chargebacks', 'read_charts_chargebacks'),
            chartsChild('refunds', 'Refunds', 'read_charts_refunds'),
            chartsChild('withdrawals', 'Withdrawals', 'read_charts_withdrawals'),
            chartsChild('pricing', 'Pricing', 'read_charts_pricing'),
            chartsChild('affiliations', 'Affiliations', 'read_charts_pricing'),
            portfolioChild('acceptance-rate', 'Acceptance rate', 'read_charts_acceptance_rate'),
            chartsChild('marketing', 'Marketing', 'read_charts_marketing'),
            chartsChild('marketing-map', 'Map', 'read_charts_marketing'),
            chartsChild('engineering/developers/:developerId', 'Developer', ENGINEERING_READ_SCOPES, 'charts/engineering-developer', 'charts-engineering-developer'),
            chartsChild('engineering/settings', 'Engineering settings', 'write_charts_engineering', 'charts/engineering-settings', 'charts-engineering-settings'),
            chartsChild('engineering', 'Engineering', ENGINEERING_READ_SCOPES),
        ],
    },
];
